import { render, staticRenderFns } from "./galleryfolders.vue?vue&type=template&id=69a595b0&"
import script from "./galleryfolders.vue?vue&type=script&lang=js&"
export * from "./galleryfolders.vue?vue&type=script&lang=js&"
import style0 from "./galleryfolders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports